import { render, staticRenderFns } from "./Naver.vue?vue&type=template&id=7864bc82&scoped=true&"
import script from "./Naver.vue?vue&type=script&lang=js&"
export * from "./Naver.vue?vue&type=script&lang=js&"
import style0 from "./Naver.vue?vue&type=style&index=0&id=7864bc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7864bc82",
  null
  
)

export default component.exports